// extracted by mini-css-extract-plugin
module.exports = {"link":"b429494557--link--h_pGy"};